module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1